export default "__VITE_ASSET__2b91ebb9__"